<template lang="pug">
  div.toolbar
    div.line
      div.view-panel
        router-link(
        tag="button"
          :to="{name: 'analytic.reports'}"
            :class="{'active': $route.name === 'analytic.reports'}"
        ).view-panel__button.view-table
        router-link(
        tag="button"
          :to="{name: 'analytic.charts'}"
            :class="{'active': $route.name.indexOf('analytic.chart') > -1}"
        ).view-panel__button.view-chart
</template>
<script>
  export default {
    props: {
      toolbarTitle: String
    },
    computed: {
      // TODO: crate global mixin with title
      title () {
        if (this.toolbarTitle) {
          return this.toolbarTitle
        } else if (this.$route.query.prevRoute) {
          if (this.$route.matched[1]) {
            return this.$route.matched[1].meta.title
          }
          return ''
        } else {
          return this.$route.meta.title
        }
      },
    },
  }
</script>
